import { fieldConfig } from "@autoform/zod";
import * as z from "zod";

// ---------------------------------------------------------------------------
// Custom field type helpers — bundle Zod type + fieldConfig in one call
// ---------------------------------------------------------------------------

/**
 * Numeric field that accepts both `.` and `,` as decimal separators.
 * Mantine's NumberInput renders comma in some locales (Greek/Slovak/etc.); raw
 * `z.coerce.number()` then fails because `Number("0,4")` is NaN. Preprocessing
 * normalises the comma to a dot before coercion so submits succeed regardless
 * of the user's locale or paste format.
 */
export const zNumber = () =>
	z.preprocess((v) => {
		if (typeof v === "string" && v.length > 0) {
			const num = Number(v.replace(",", "."));
			return Number.isFinite(num) ? num : v;
		}
		return v;
	}, z.number());

/** URL field with link icon and placeholder. Validates via Zod's built-in URL check. */
export const zUrl = () => z.url().check(fieldConfig({ fieldType: "url" }));

/** Color picker field. Renders Mantine's ColorInput. */
export const zColor = () => z.string().check(fieldConfig({ fieldType: "color" }));

/**
 * Image asset upload field. Stores the uploaded URL as a string.
 *
 * Pass `accept` as an array of lowercase extensions (no dot, e.g. `['svg']`,
 * `['png', 'jpg']`) to restrict the file picker AND reject mismatched files
 * before upload. Default: any image type.
 */
export const zImageAsset = (options?: { accept?: string[] }) =>
	z.string().check(
		fieldConfig({
			fieldType: "imageAsset",
			customData: options?.accept ? { accept: options.accept } : undefined,
		}),
	);
